import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ChangeOsnTypeModal from "@WhiteCap/Components/OSNSubscriptions/ChangeOsnTypeModal";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        osnTypeSelectionConfirmed: state.WhiteCap.subscriptionsDashboardData.osnTypeSelectionConfirmed,
        modifyingOsnTypeSelection: state.WhiteCap.subscriptionsDashboardData.modifyingOsnTypeSelection,
    };
};


type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const mapDispatchToProps = {};

const NotificationtypeSelectionModal: FC<Props> = ({ osnTypeSelectionConfirmed, modifyingOsnTypeSelection }) => {
    console.log("");
    return (
        osnTypeSelectionConfirmed && !modifyingOsnTypeSelection? null : <ChangeOsnTypeModal/>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NotificationtypeSelectionModal),
    definition: {
        group: "My Account",
        displayName: "NotificationtypeSelectionModal",
        fieldDefinitions: [],
    },
};

export default widgetModule;
